/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstLiveMusicBookingUnlockedSvg({ size, accessibilityLabel, testID }: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M84.5601 77.0917C84.5601 77.0917 53.1652 89.5147 50.3505 89.5147C47.5358 89.5147 16.0683 77.2176 16.0683 77.2176C14.6937 77.2196 14.6202 24.3352 15.9958 24.3331C15.9958 24.3331 48.425 10.4277 50.3515 10.4277C52.278 10.4277 84.4886 24.2073 84.4886 24.2073C85.12 24.2073 85.1926 77.0907 84.5611 77.0917H84.5601Z"
          fill="url(#paint0_linear_8631_21229)"
        />
        <Path
          d="M50.3516 89.5158C53.1663 89.5158 84.5612 77.0927 84.5612 77.0927C85.1926 77.0927 85.1201 24.2073 84.4887 24.2083C84.4887 24.2083 52.2781 10.4287 50.3516 10.4287V89.5168V89.5158Z"
          fill="url(#paint1_linear_8631_21229)"
        />
        <Path
          d="M83.2512 26.175C83.2512 26.175 52.1956 12.7963 50.3386 12.7963C48.4816 12.7963 17.2146 26.2969 17.2146 26.2969C15.8883 26.2989 15.9588 77.6426 17.2851 77.6406C17.2851 77.6406 47.6246 89.5792 50.3386 89.5792C53.0526 89.5792 83.3217 77.5177 83.3217 77.5177C83.9299 77.5177 83.8604 26.173 83.2512 26.174V26.175ZM80.5613 75.3576C80.5613 75.3576 52.8291 86.408 50.3426 86.408C47.8562 86.408 20.0595 75.4694 20.0595 75.4694C18.845 75.4714 18.7805 28.4298 19.995 28.4288C19.995 28.4288 48.6417 16.0602 50.3426 16.0602C52.0435 16.0602 80.4969 28.317 80.4969 28.317C81.0548 28.317 81.1192 75.3576 80.5613 75.3576Z"
          fill="#BCB6C3"
        />
        <Path
          d="M84.4877 24.2073C84.4877 24.2073 52.2771 10.4277 50.3516 10.4277C48.4261 10.4277 15.9959 24.3331 15.9959 24.3331C14.6213 24.3352 14.6938 77.2196 16.0684 77.2176C16.0684 77.2176 47.5359 89.5147 50.3506 89.5147C53.1653 89.5147 84.5602 77.0917 84.5602 77.0917C85.1916 77.0917 85.1191 24.2063 84.4877 24.2073ZM81.6972 74.8661C81.6972 74.8661 52.9337 86.2489 50.3546 86.2489C47.7755 86.2489 18.9456 74.9819 18.9456 74.9819C17.6858 74.984 17.6193 26.5315 18.8791 26.5295C18.8791 26.5295 48.5902 13.7893 50.3546 13.7893C52.119 13.7893 81.6307 26.4137 81.6307 26.4137C82.2088 26.4137 82.2762 74.8651 81.6972 74.8661Z"
          fill="url(#paint2_linear_8631_21229)"
        />
        <Path
          d="M24.0935 31.1056V71.7241C24.0935 71.7473 24.1076 71.7684 24.1277 71.7775L42.5901 79.8561C42.7754 79.9376 42.9385 79.704 42.7975 79.558L30.4269 66.6969C30.4188 66.6888 30.4138 66.6778 30.4118 66.6667L24.2093 31.0955C24.1972 31.026 24.0945 31.0341 24.0945 31.1056H24.0935Z"
          fill="#E3DEED"
        />
        <Path
          d="M75.3808 31.1056V71.7241C75.3808 71.7473 75.3667 71.7684 75.3466 71.7775L56.8842 79.8561C56.699 79.9376 56.5358 79.704 56.6768 79.558L69.0475 66.6969C69.0555 66.6888 69.0605 66.6778 69.0626 66.6667L75.265 31.0955C75.2771 31.026 75.3798 31.0341 75.3798 31.1056H75.3808Z"
          fill="#EFEEF0"
        />
        <Path
          d="M59.4765 41.8349C59.4765 41.4869 59.284 41.1835 58.9909 41.0055C58.8158 40.8963 58.6102 40.8275 58.3827 40.8275H50.8698V40.8397H44.0614C43.4663 40.8397 42.985 41.2847 42.985 41.8349V43.5219H42.9587V49.4972H42.985V59.7244C42.985 60.2301 43.3919 60.6427 43.9214 60.7075V90.5881L46.8136 93.5413H48.717V96.2883C48.717 96.9477 49.2946 97.4858 50.0122 97.4858H52.3969C53.1101 97.4858 53.692 96.9477 53.692 96.2883V93.5413H55.591L58.4833 90.5881V60.7115C58.6058 60.7034 58.7239 60.6791 58.829 60.6346C58.9515 60.5861 59.0652 60.5173 59.1571 60.4283C59.354 60.2463 59.4722 59.9995 59.4722 59.7244V49.4972H59.4984V43.5219H59.4722V41.8349H59.4765Z"
          fill="#7F8AA5"
        />
        <Path
          d="M68.3722 19.7501C62.6271 19.6651 56.8557 19.7501 51.1106 19.7501C56.8557 19.7501 62.6271 19.6611 68.3722 19.7501C68.5472 19.5316 68.4116 19.3172 68.3591 19.0947C66.5651 11.6306 59.3191 6.31474 51.1106 6.4887C50.4498 6.50084 49.7454 6.43611 49.0978 6.50893C41.6899 7.31399 35.0303 12.8119 34.0152 19.7501C33.477 19.7582 32.93 19.742 32.3875 19.7501V25.4746C32.9256 25.4827 33.4726 25.4665 34.0152 25.4746C35.2272 33.2825 42.6788 38.829 51.1106 38.8856C59.7742 38.9423 66.9764 33.3351 68.5341 25.4786C69.0198 25.4705 69.5142 25.4867 69.9999 25.4786V19.7501C69.4574 19.742 68.9104 19.7582 68.3722 19.7501ZM38.6183 17.2742C38.7233 17.0031 38.8064 16.7604 38.8677 16.639C38.8064 16.7645 38.7189 17.0031 38.6183 17.2742ZM46.875 9.58356C46.8619 10.1135 44.3153 11.0116 43.7377 11.3393C44.3153 11.0116 46.8662 10.1135 46.875 9.58356ZM38.3426 14.5879C37.9051 15.2959 36.9818 16.9384 36.9424 17.9053C36.9774 16.9425 37.9007 15.2959 38.3426 14.5879ZM38.0101 18.4595C37.8832 18.6052 37.7475 18.7023 37.5944 18.7144C37.7432 18.7023 37.8832 18.6052 38.0101 18.4595ZM43.5714 33.8853C41.7206 32.8982 40.1016 31.3609 39.034 29.6456C38.9464 29.504 38.7977 29.1965 38.6314 28.8526C38.7933 29.1965 38.9421 29.504 39.034 29.6456C40.1016 31.3568 41.7206 32.8942 43.5714 33.8853ZM36.6493 27.7199C36.7324 27.3072 37.0518 27.0523 37.4062 27.0847C37.0562 27.0523 36.7368 27.3072 36.6493 27.7199ZM37.9182 27.3679C37.9182 27.3679 37.9182 27.3598 37.9138 27.3598C37.9138 27.3598 37.9138 27.3679 37.9182 27.3679ZM37.9138 27.3558C37.9138 27.3558 37.8919 27.3274 37.8876 27.3194C37.8613 27.2951 37.835 27.2749 37.8044 27.2546C37.8307 27.2749 37.8569 27.2951 37.8876 27.3194C37.8963 27.3274 37.9051 27.3396 37.9138 27.3558ZM36.6974 28.3672C37.0212 29.4716 38.4739 31.4054 39.6509 32.6716C38.4695 31.4054 37.0212 29.4716 36.6974 28.3672ZM46.9144 36.2115C47.2732 36.0092 47.3563 35.6087 46.9713 35.2608C47.3607 35.6087 47.2732 36.0092 46.9144 36.2115ZM38.2857 25.511C42.5607 25.5231 46.8444 25.4746 51.1106 25.4746C46.84 25.4746 42.5607 25.5231 38.2857 25.511Z"
          fill="#7F8AA5"
        />
        <Path
          d="M55.4212 59.4535H40.8599V91.7584H55.4212V59.4535Z"
          fill="url(#paint3_linear_8631_21229)"
        />
        <Path d="M55.3799 91.6716V61.006H51.5226V91.6716H55.3799Z" fill="#AE7FDB" />
        <Path
          d="M51.6191 91.6716V61.006H43.0366V91.6716H51.6191Z"
          fill="url(#paint4_linear_8631_21229)"
        />
        <Path d="M55.4212 59.3676H40.8599V61.2963H55.4212V59.3676Z" fill="#8153AD" />
        <Path
          d="M52.5282 94.9512H43.7528L40.8599 91.7584H55.4212L52.5282 94.9512Z"
          fill="#8153AD"
        />
        <Path d="M56.3857 41.4206H39.8958V47.303H56.3857V41.4206Z" fill="#265CEC" />
        <Path
          d="M55.3354 37.949H41.0017C40.4063 37.949 39.9236 38.4317 39.9236 39.0271V58.3754C39.9236 58.9708 40.4063 59.4535 41.0017 59.4535H55.3354C55.9308 59.4535 56.4135 58.9708 56.4135 58.3754V39.0271C56.4135 38.4317 55.9308 37.949 55.3354 37.949Z"
          fill="url(#paint5_linear_8631_21229)"
        />
        <Path
          d="M56.3906 39.005V58.4255C56.3906 58.9858 55.9355 59.441 55.3752 59.441H47.8081V37.9365H55.3212C55.9114 37.9365 56.3906 38.4158 56.3906 39.006V39.005Z"
          fill="url(#paint6_linear_8631_21229)"
        />
        <Path
          d="M56.4407 40.8526H39.8958V47.3136H56.4407V40.8526Z"
          fill="url(#paint7_linear_8631_21229)"
        />
        <Path
          d="M50.6275 94.9503V97.9214C50.6275 98.635 50.0479 99.2145 49.3343 99.2145H46.9486C46.235 99.2145 45.6554 98.635 45.6554 97.9214V94.9503H50.6284H50.6275Z"
          fill="url(#paint8_linear_8631_21229)"
        />
        <Path
          d="M48.3884 90.4189C49.6399 90.4189 50.6545 89.4043 50.6545 88.1528C50.6545 86.9012 49.6399 85.8866 48.3884 85.8866H47.9477C46.6961 85.8866 45.6815 86.9012 45.6815 88.1528C45.6815 89.4043 46.6961 90.4189 47.9477 90.4189H48.3884Z"
          fill="url(#paint9_linear_8631_21229)"
        />
        <Path
          d="M65.4715 21.3347C63.9151 29.8343 56.7145 35.8979 48.0491 35.8382V21.3347C53.8466 21.3366 59.6759 21.4475 65.4715 21.3347Z"
          fill="url(#paint10_linear_8631_21229)"
        />
        <Path
          d="M65.3086 15.1418C59.565 15.0473 53.7945 15.1399 48.0491 15.1418V0.801323C56.2574 0.611351 63.5024 6.36355 65.296 14.4349C65.3491 14.6751 65.4821 14.9046 65.3086 15.1418Z"
          fill="url(#paint11_linear_8631_21229)"
        />
        <Path
          d="M48.0491 21.3347V35.8381C39.6161 35.7803 32.1638 29.7773 30.9526 21.3347C36.6422 21.4302 42.3577 21.3328 48.0491 21.3347ZM34.8225 23.3289C34.2043 22.7011 33.3904 23.3029 33.593 24.3106C33.8948 25.814 36.3683 29.083 37.5525 30.1293C38.6306 31.0811 42.0279 33.1959 43.4107 33.0811C44.0973 33.0242 44.4243 32.4167 43.9054 31.9172C43.5911 31.6144 41.2642 30.8641 40.5091 30.4283C38.6576 29.3588 37.0385 27.6954 35.9719 25.8439C35.7145 25.3964 34.942 23.4514 34.8225 23.3289Z"
          fill="url(#paint12_linear_8631_21229)"
        />
        <Path
          d="M48.0492 0.801348V15.1418C42.3577 15.1438 36.6422 15.0464 30.9526 15.1418C31.97 7.64034 38.6296 1.69045 46.0356 0.821598C46.6856 0.745417 47.3896 0.815812 48.0501 0.800383L48.0492 0.801348ZM42.6325 3.44456C40.1754 3.94697 36.6537 7.26425 35.3808 9.38866C34.916 10.1649 33.3856 13.0058 34.0443 13.7609C34.9797 14.8323 35.5554 12.3125 35.809 11.7734C36.9247 9.40312 38.4078 7.43687 40.673 6.04824C41.2526 5.69337 43.8003 4.72036 43.8119 4.14755C43.8254 3.43974 43.2073 3.32691 42.6325 3.44456Z"
          fill="url(#paint13_linear_8631_21229)"
        />
        <Path
          d="M65.3086 15.1418C65.8495 15.1505 66.3963 15.135 66.9373 15.1418V21.3366C66.4503 21.3434 65.9575 21.326 65.4715 21.3366C59.6769 21.4494 53.8476 21.3385 48.0491 21.3366V15.1437C53.7945 15.1418 59.565 15.0492 65.3086 15.1437V15.1418Z"
          fill="#8153AD"
        />
        <Path
          d="M30.9525 15.1418C36.642 15.0463 42.3576 15.1437 48.049 15.1418V21.3347C42.3576 21.3328 36.642 21.4302 30.9525 21.3347C30.4115 21.326 29.8647 21.3414 29.3247 21.3347V15.1418C29.8657 15.135 30.4125 15.1505 30.9525 15.1418Z"
          fill="#B784EA"
        />
        <Path
          d="M34.8221 23.3289C34.9417 23.4504 35.7141 25.3964 35.9716 25.8439C37.0381 27.6963 38.6572 29.3588 40.5087 30.4283C41.2638 30.8641 43.5897 31.6134 43.9051 31.9172C44.4229 32.4167 44.097 33.0242 43.4104 33.0811C42.0266 33.1959 38.6302 31.0811 37.5521 30.1293C36.3679 29.083 33.8954 25.814 33.5926 24.3106C33.3901 23.3029 34.2049 22.7011 34.8221 23.3289Z"
          fill="#F7F0CF"
        />
        <Path
          d="M42.6325 3.44454C43.2072 3.32689 43.8254 3.43972 43.8119 4.14753C43.8003 4.72034 41.2525 5.69335 40.673 6.04822C38.4088 7.43685 36.9247 9.4031 35.8089 11.7734C35.5553 12.3125 34.9796 14.8323 34.0442 13.7609C33.3856 13.0068 34.916 10.1649 35.3808 9.38864C36.6537 7.26423 40.1754 3.94599 42.6325 3.44454Z"
          fill="#F7F0CF"
        />
        <Path
          d="M49.1378 49.3531C50.8061 50.2104 50.4551 55.8826 49.4233 56.6984C49.105 56.9501 47.4059 57.0147 47.0703 56.9125C46.3451 56.6926 45.9556 54.8787 45.8582 54.2027C49.0867 54.4756 49.7743 51.7369 48.5679 49.2104C48.5968 49.2114 49.0433 49.3261 49.1388 49.3531H49.1378Z"
          fill="#363544"
        />
        <Path
          d="M48.5668 49.2104C49.7722 51.737 49.0846 54.4747 45.857 54.2027C45.6295 52.629 45.5639 50.9221 46.7124 49.6386C47.5244 49.248 47.588 49.1748 48.5668 49.2104Z"
          fill="url(#paint14_linear_8631_21229)"
        />
        <Path
          d="M46.7134 49.6376C45.564 50.9211 45.6305 52.628 45.8581 54.2018C45.9555 54.8778 46.346 56.6916 47.0702 56.9115C47.4068 57.0137 49.105 56.9491 49.4232 56.6974C50.455 55.8816 50.806 50.2085 49.1377 49.3522C51.456 50.0012 51.1011 56.9858 48.9237 57.4824C48.7829 57.5142 47.023 57.5113 46.9265 57.4824C45.0355 56.9183 44.5678 50.6704 46.7125 49.6376H46.7134Z"
          fill="#F8F8FD"
        />
        <Path
          d="M43.5005 65.9738C43.5005 65.4412 43.263 65.0095 42.9701 65.0095C42.6772 65.0095 42.4397 65.4412 42.4397 65.9738V83.4281C42.4397 83.9606 42.6772 84.3924 42.9701 84.3924C43.263 84.3924 43.5005 83.9606 43.5005 83.4281V65.9738Z"
          fill="#F8F8FD"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_21229"
            x1="50"
            y1="10.4277"
            x2="50"
            y2="89.5147"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_21229"
            x1="67.6758"
            y1="10.4287"
            x2="67.6758"
            y2="89.5168"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_21229"
            x1="49.9998"
            y1="10.4277"
            x2="49.9998"
            y2="89.5147"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_8631_21229"
            x1="48.1405"
            y1="59.4535"
            x2="26.9138"
            y2="80.6802"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EAD8FC" />
            <Stop offset="1" stopColor="#C18CF6" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_8631_21229"
            x1="51.6191"
            y1="76.3388"
            x2="40.5171"
            y2="74.9383"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#D2AEF7" />
            <Stop offset="1" stopColor="#A777D7" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_8631_21229"
            x1="48.1686"
            y1="37.949"
            x2="35.8227"
            y2="58.952"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EAD8FC" />
            <Stop offset="1" stopColor="#C18CF6" />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_8631_21229"
            x1="56.3906"
            y1="48.6887"
            x2="45.4655"
            y2="46.7234"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#D2AEF7" />
            <Stop offset="1" stopColor="#A777D7" />
          </LinearGradient>
          <LinearGradient
            id="paint7_linear_8631_21229"
            x1="48.1682"
            y1="40.8526"
            x2="44.7822"
            y2="48.0709"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
          <LinearGradient
            id="paint8_linear_8631_21229"
            x1="50.6284"
            y1="97.0824"
            x2="48.3403"
            y2="93.877"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
          <LinearGradient
            id="paint9_linear_8631_21229"
            x1="50.6545"
            y1="88.1528"
            x2="48.1781"
            y2="84.8887"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_8631_21229"
            x1="56.7603"
            y1="21.3347"
            x2="46.8755"
            y2="31.2195"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
          <LinearGradient
            id="paint11_linear_8631_21229"
            x1="56.722"
            y1="0.796753"
            x2="45.7665"
            y2="11.7522"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
          <LinearGradient
            id="paint12_linear_8631_21229"
            x1="39.5009"
            y1="21.3347"
            x2="39.5009"
            y2="35.8381"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#8BA9F9" />
          </LinearGradient>
          <LinearGradient
            id="paint13_linear_8631_21229"
            x1="39.5014"
            y1="0.785461"
            x2="39.5014"
            y2="15.1418"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#8BA9F9" />
          </LinearGradient>
          <LinearGradient
            id="paint14_linear_8631_21229"
            x1="47.4228"
            y1="49.2024"
            x2="44.4953"
            y2="50.8537"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#265CEC" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstLiveMusicBookingUnlocked = styled(FirstLiveMusicBookingUnlockedSvg).attrs(
  ({ size, theme }) => ({
    size: size ?? theme.illustrations.sizes.medium,
  })
)``
